import React from 'react'
import Checkbox from 'react-bootstrap/FormCheck';
import Form from 'react-bootstrap/Form'

import './styles.scss';

const InputCheckbox = ({legend, handleChange, error, value, checked, disabled, title}) => {

return <span>
        <div className="input-checkbox">
        <Form.Group>
            <Form.Control type="checkbox" onChange={handleChange} value={value} checked={checked} disabled={disabled} title={title}/>
            <Form.Label>{legend}</Form.Label>
        </Form.Group>
        </div>
        <div className="input-error">
            {error}
        </div>
    </span>
}

export default InputCheckbox;